export const NavStepWizard = (props: any) => {
  const resultCss = `progtrckr-${
    props.currentStep === props.stepKey
      ? 'doing'
      : props.stepKey > props.currentStep
        ? 'todo'
        : 'done'
  }`;

  return (
    <li
      className={resultCss}
      value={props.stepKey - 1}
      onClick={() => {
        if (props.stepKey < props.currentStep) {
          props.goToStep(props.stepKey);
        }
      }}
    >
      <em> {props.stepKey}</em>
      <span> {props.label}</span>
    </li>
  );
};
